export default "__VITE_ASSET__634c6145__"